import axios from 'axios';
import { IRecipient } from '@/types/Recipient';

export const validateContact = async (mobile: string) => {
  const body = new FormData();
  body.append('mobile', escape(mobile));
  const { data } = await axios.post('/get/contact/validate', body);
  return data || {};
};

export const saveRecipientMobile = async (
  recipientId: string,
  documentId: string,
  mobile: string
) => {
  const body = new FormData();
  body.append('action', 'mobile');
  body.append('document-id', documentId);
  body.append('recipient-id', recipientId);
  body.append('mobile', mobile);
  const { data } = await axios.post('/save/recipient', body);
  return data || {};
};

const searchRecipient = async (query: string, documentId: string) => {
  const { data }: { data: any } = await axios.get(
    `/get/contact/search?query=${query}&document-id=${documentId}`
  );
  if (!data?.result) {
    return [];
  }
  const searchResult: IRecipient[] = [];

  data.result.forEach(searchItem => {
    const recipient: IRecipient = {
      companyNumber: searchItem.company_id,
      companyName: searchItem.company_name,
      contactId: searchItem.contact_id,
      email: searchItem.email,
      firstName: searchItem.first_name,
      lastName: searchItem.last_name,
      thumbUrl: searchItem.thumb_url,
    };
    searchResult.push(recipient);
  });
  return searchResult;
};

const getRoleDetails = async (recipientId: string) => {
  const { data }: { data: any } = await axios.get(`/get/recipient/${recipientId}/details`);
  const recipientData = data?.result[0];
  if (!recipientData) {
    return;
  }
  return {
    documentId: recipientData.document_id,
    id: recipientData.recipient_id,
    role: recipientData.role,
    roleName: recipientData.role_name,
    verifyEid: recipientData.verify_eid,
    verifySms: recipientData.verify_sms,
    verifySmsOpen: recipientData.verify_sms_open,
    verifySmsSign: recipientData.verify_sms_sign,
  };
};

export default {
  getRoleDetails,
  searchRecipient,
};
